//自定义指令，限制el-input框 数字输入，可绑定model同步更新， eg: v-digits:2.neq="model.field"
import Vue from 'vue';
export default {
    bind: function (el, bd, vn) {
        el.oninput = e => {
            e.target.value = getValidNumber({
                value: String(e.target.value),
                precision: Number(bd.arg),//小数点精确度
                neq: bd.modifiers['neq'],//是否允许负数-
                sign: bd.modifiers['sign'],//是否允许正数符号+
            });
            syncModel(vn.context, bd.expression, e.target.value);
        };
        //onblur是原生事件，el-input重新渲染到div上了，监听不到
        el.querySelector('input').onblur = e => {
            let v = String(e.target.value);
            v = v.replace(/\.$/g, '').replace(/^[+-]$/g,'');
            e.target.value = v;
            syncModel(vn.context, bd.expression, e.target.value);
        };
    },
    /*update(el, bd, vn) {
    },*/
};

//获取有效的数值
function getValidNumber(config) {
    let v = config.value;
    let precision = config.precision;
    let neq = config.neq; //-
    let sign = config.sign; //+
    v = v.replace(/[^-\d+.]/g,'').replace(new RegExp("(?<=\\S+)[+-]","g"),'').replace(new RegExp("(?<!\\d)\\.","g"),'');
    if (!neq) {
        v = v.replace(/-/g,'');
    }
    if (!sign) {
        v = v.replace(/\+/g,'');
    }
    if (v.indexOf('.') !== v.lastIndexOf('.')) {
        v = v.substring(0, v.lastIndexOf('.'));
    }
    if (!isNaN(precision)) {
        if (precision === 0) {
            v = v.replace(/\./g, '');
        }else {
            let ex1 = new RegExp("(?<=\\d+\\.)\\d+$").exec(v);
            if (ex1 && ex1[0].length > precision) {
                v = v.substring(0, v.lastIndexOf('.') + precision + 1);
            }
        }
    }
    return v;
}

//同步绑定组件中的data中存在的model变量值 （注：scope.row.field 不能使用）
function syncModel(model,expression,value) {
    let fLevels = String(expression).split('.');
    let syncParent = model;
    let lastField = '';
    fLevels.forEach((item,index) => {
        if (index !== fLevels.length - 1) {
            syncParent = syncParent[item];
        }else{
            lastField = item;
        }
    });
    Vue.set(syncParent, lastField, value);
}